module.exports = __webpack_public_path__ + "static/media/20.Snake Hiss.5e2c57a1.wav";